export const alertConstants = {
  OPEN_MODAL_ALERT: 'OPEN_MODAL_ALERT',
  CLOSE_MODAL_ALERT: 'CLOSE_MODAL_ALERT'
};
